import classNames from 'classnames';
import React, { FC, ForwardRefExoticComponent, HTMLAttributes, RefAttributes, useEffect, useRef } from 'react';
import { BsPrefixRefForwardingComponent } from 'react-bootstrap/esm/helpers';
import ReactSlider, { ReactSliderProps } from 'react-slider';
import useResizeObserver from 'use-resize-observer';
import styles from './RangeSlider.module.scss';
import { FormRangeSliderLabel, FormRangeSliderLabelProps } from './RangeSliderLabel';

export type FormRangeSliderProps = BsPrefixRefForwardingComponent<'div', Omit<ReactSliderProps<number | number[]>, 'children'>> & {
	Label: ForwardRefExoticComponent<FormRangeSliderLabelProps & HTMLAttributes<HTMLSpanElement> & RefAttributes<HTMLSpanElement>>;
};

export const FormRangeSlider: FC<FormRangeSliderProps> = ({ children, ...props }) => {
	const sliderRef = useRef<ReactSlider & { slider?: HTMLDivElement }>(null);
	const { ref } = useResizeObserver<HTMLDivElement>({
		ref: sliderRef?.current?.slider,
	});

	useEffect(() => {
		sliderRef?.current?.resize();
	}, [ref]);

	return (
		<>
			<ReactSlider
				{...props}
				ref={sliderRef as any}
				className={styles.rangeSlider}
				thumbClassName={styles.rangeSliderThumb}
				thumbActiveClassName={styles.rangeSliderThumbActive}
				renderTrack={(props, state) => (
					<div
						{...props}
						className={classNames(styles.rangeSliderTrack, {
							[styles[`rangeSliderTrack--active`]]: typeof state.value === 'number' ? state.index === 0 : state.index === 1,
						})}
					/>
				)}
			/>

			{children && <div className={styles.rangeSliderLabels}>{children}</div>}
		</>
	);
};

export default Object.assign(FormRangeSlider, {
	Label: FormRangeSliderLabel,
});
